module.exports = __webpack_public_path__ + "img/testpaper_audio_noplay.291d0151.svg";